import React, { Component } from "react";
import axios from "../../utils/axiosInstance";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./TestimonialSlider.css";

class TestimonialSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      testimonials: [],
      activeIndex: 0,
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchTestimonials();
  }

  fetchTestimonials = async () => {
    try {
      this.setState({ loading: true });

      const response = await axios.get("/get_testimonials");
      const data = response.data?.data || response.data || [];

      this.setState({
        testimonials: data,
        activeIndex: data.length > 1 ? 1 : 0,
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching testimonials:", error);
      this.setState({ loading: false });
    }
  };

  handleDotClick = (index) => {
    this.setState({
      activeIndex: index,
    });
  };

  getTransformOffset = () => {
    const slideWidth = 432;
    const centerIndex = 1;

    return `translateX(${(centerIndex - this.state.activeIndex) * slideWidth
      }px)`;
  };

  render() {
    const { testimonials, activeIndex, loading } = this.state;

    const baseUrl = axios.defaults.baseURL
      ? axios.defaults.baseURL.replace("/api", "")
      : "";

    return (
      <section className="testimonials-section py-5">
        {/* Header */}
        <div className="text-center mb-5">
          <h2 className="testimonial-main-title">What Our Guests Say</h2>

          <div className="testimonial-subtitle-wrapper">
            <span className="testimonial-subtitle">Testimonial</span>

            <svg
              className="testimonial-subtitle-underline"
              viewBox="0 0 150 15"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5,10 Q75,2 145,12"
                fill="none"
                stroke="#0047CC"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        {/* Slider */}
        {loading ? (
          <div className="text-center py-5">
            Loading testimonials...
          </div>
        ) : testimonials.length === 0 ? null : (
          <div className="slider-viewport">
            <div
              className="slider-track"
              style={{
                transform: this.getTransformOffset(),
              }}
            >
              {testimonials.map((testimonial, index) => {
                const avatarSrc = testimonial.testimonial_image
                  ? testimonial.testimonial_image.startsWith("http")
                    ? testimonial.testimonial_image
                    : `${baseUrl}/uploads/testimonials/${testimonial.testimonial_image}`
                  : "";

                return (
                  <div
                    key={testimonial.id || index}
                    className={`testimonial-card d-flex flex-column justify-content-between ${index === activeIndex ? "active" : ""
                      }`}
                  >
                    {/* Quote Icon */}
                    <div className="quote-icon-wrapper mb-3">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="#0047CC"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z" />
                      </svg>
                    </div>

                    {/* Testimonial */}
                    <p className="testimonial-text mb-4">
                      {testimonial.testimonial_message}
                    </p>

                    {/* Author */}
                    <div className="testimonial-author d-flex justify-content-between align-items-end mt-auto">
                      <img
                        src={avatarSrc}
                        alt={testimonial.testimonial_name}
                        className="author-image"
                      />

                      <div className="author-info text-end">
                        <h5 className="author-name m-0">
                          {testimonial.testimonial_name}
                        </h5>

                        <span className="author-role">
                          {testimonial.testimonial_designation}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Dots */}
        {!loading && testimonials.length > 0 && (
          <div className="pagination-dots d-flex justify-content-center mt-4">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === activeIndex ? "active" : ""
                  }`}
                onClick={() => this.handleDotClick(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Button */}
        {!loading && testimonials.length > 0 && (
          <div className="text-center mt-5">
            <button className="btn-view-testimonials d-inline-flex align-items-center gap-2">
              View all testimonials
              <i className="bi bi-arrow-up-right"></i>
            </button>
          </div>
        )}
      </section>
    );
  }
}

export default TestimonialSlider;